<template>
    <div class="score-section" :class="{ 'is-active': isActive }">
        <button 
            class="task-name" 
            @click="navigateToTask"
            :class="{ 'active': isActive }"
        >
            <span>{{ taskName }}</span>
        </button>
        <div class="scores">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScoreSection',
    props: {
        taskName: {
            type: String,
            required: true,
        },
        route: {
            type: String,
            required: true,
        },
        currentRoute: {
            type: String,
            default: '',
        }
    },
    computed: {
        isActive() {
            return this.currentRoute === this.route;
        }
    },
    methods: {
        navigateToTask() {
            this.$router.push(this.route);
        }
    }
};
</script>

<style scoped>
.score-section {
    display: flex;
    border: 1px solid #ccc;
    margin: 10px 0;
    padding: 10px;
    border-radius: 8px;
    background-color: #f9f9f9;
    transition: margin-left 0.2s ease;
}

.score-section.is-active {
    margin-left: 20px;
    background-color: #f0f8ff;
}

.task-name {
    writing-mode: vertical-lr;
    text-orientation: mixed;
    transform: rotate(180deg);
    text-align: center;
    margin-right: 20px;
    font-weight: bold;
    background-color: #317391;
    color: white;
    padding: 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease;
}

.task-name:hover {
    background-color: #4a9bc7;
    transform: rotate(180deg) scale(1.05);
    box-shadow: 0 2px 8px rgba(49, 115, 145, 0.4);
}

.task-name.active {
    background-color: #1a5a7a;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.task-name:active {
    transform: rotate(180deg) scale(0.98);
}

.scores {
    flex: 1;
    flex-direction: column;
    display: flex;
    margin: 20px;
    font-size: 14px;
    max-width: 350px;
}
</style>
  